import { DLink } from '@dnse/ui';
import { BasePath } from '../../constants/basePath';
import React from 'react';

interface Props {
  title: string;
  subTitle: string;
  basePath: string;
  slug: string;
}
export const TopPostTitle: React.FC<Props> = ({ title, subTitle, basePath, slug }) => {
  return <div>
    <div
      className="hidden md:block py-6 pl-10 pr-4 w-[455px] absolute right-0 top-[49px] flex flex-col gap-y-4"
      style={{
        background: 'rgba(245, 245, 245, 0.50)',
        boxShadow: '1px 2px 3px 0px rgba(0, 0, 0, 0.15)',
        backdropFilter: 'blur(6px)',
        borderRadius: "8px"
      }}
    >
      <div className="w-[155px] h-[6px] bg-brand-300" />
      <DLink href={`${basePath}/${slug}`}>
        <h4 className="text-[32px] font-bold">{title}</h4>
      </DLink>
      <div className="line-clamp-4 text-gray-700 text-base font-normal leading-6">
        {subTitle}
      </div>
    </div>
    <div className="md:hidden">
      <DLink href={`${basePath}/${slug}`}>
        <h4 className="font-bold text-[28px]">{title}</h4>
      </DLink>
      <div className="line-clamp-4 text-gray-700 text-base font-normal leading-6">
        {subTitle}
      </div>
    </div>
  </div>
}
